var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Paper } from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
var useStyles = makeStyles(function (theme) {
    var _a;
    return ({
        paper: (_a = {
                position: "fixed",
                zIndex: 1201,
                bottom: 0,
                display: "flex",
                alignItems: "center",
                left: function (_a) {
                    var fullWidth = _a.fullWidth;
                    return (fullWidth ? 0 : 256);
                },
                right: 0,
                width: function (_a) {
                    var fullWidth = _a.fullWidth;
                    return (fullWidth ? "100%" : "calc(100% - 256px)");
                },
                boxSizing: "border-box"
            },
            _a[theme.breakpoints.down("sm")] = {
                left: 0,
                right: 0,
                width: "100%",
            },
            _a.justifyContent = "space-between",
            _a.padding = "10px 20px calc(5px + env(safe-area-inset-bottom)) 20px",
            _a.color = theme.palette.type === "dark" ? "#fff" : "#2f343b",
            _a.backgroundColor = theme.palette.type === "dark"
                ? "rgba(13, 18, 27, 0.42)"
                : "rgba(22, 32, 46, 0.26)",
            _a.backdropFilter = "blur(24px) saturate(155%)",
            _a.WebkitBackdropFilter = "blur(24px) saturate(155%)",
            _a.borderColor = "rgba(255, 255, 255, 0.16)",
            _a.boxShadow = "0 -18px 46px rgba(0, 0, 0, 0.18)",
            _a["& .MuiIconButton-root"] = {
                color: theme.palette.type === "dark"
                    ? "rgba(255, 255, 255, 0.88)"
                    : "rgba(47, 52, 59, 0.82)",
            },
            _a["& .MuiIconButton-root.Mui-disabled"] = {
                color: theme.palette.type === "dark"
                    ? "rgba(255, 255, 255, 0.34)"
                    : "rgba(47, 52, 59, 0.34)",
            },
            _a["& .MuiTypography-root"] = {
                color: "inherit",
            },
            _a["& .MuiTypography-caption"] = {
                color: theme.palette.type === "dark"
                    ? "rgba(255, 255, 255, 0.7)"
                    : "rgba(47, 52, 59, 0.66)",
            },
            _a["& .MuiSlider-root"] = {
                color: theme.palette.type === "dark"
                    ? "rgba(255, 255, 255, 0.78)"
                    : "rgba(47, 52, 59, 0.72)",
            },
            _a),
    });
});
export var PlayerContainer = function (_a) {
    var className = _a.className, _b = _a.fullWidth, fullWidth = _b === void 0 ? false : _b, props = __rest(_a, ["className", "fullWidth"]);
    var classes = useStyles({ fullWidth: fullWidth });
    return (React.createElement(Paper, __assign({ className: clsx(classes.paper, className), variant: "outlined", square: true }, props)));
};
